module.exports = "images/france-3.882a2f8d.png";